import { createRouter, createWebHistory ,createWebHashHistory } from 'vue-router'
import {useMutitabsStore} from "@/store/mutitabs";
import {setStorage,getStorage} from '@/utils/util'
// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import '../assets/css/nprogress.scss'//自定义样式
// 简单配置
NProgress.inc(0.4)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: true })

const routes = [
  {
    path: '/',
    name: 'root',
    component: () => import('../views/login.vue'),
    hidden: true,
    meta: {
      requireAuth: false,
      index: '/',
    }
  },
    {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    hidden: true,
    meta: {
      requireAuth: false,
      index: '/login',
    }
  },
    {
    path: '/404',
    name: '404',
    component: () => import('../views/error/404.vue'),
    hidden: true,
    meta: {
      requireAuth: false,
      index: '/404',
    }
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/index.vue'),
    iconCls: 'el-icon-tickets',
    meta: {
      requireAuth: false,
      index: '/index',
    },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/DashBoard/billingSummary.vue'),
        meta: {
          requireAuth: true,
          title: '仪表盘',
          icon: 'el-icon-odometer'
        },
        beforeEnter: (to, from, next) => {
          const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
          // 伙伴(2)/客户(4) 统一进入角色自适应的 Sales Overview
          if (userInfo.type === 2 || userInfo.type === 4) {
            next('/salesOverview');
          } else {
            next();
          }
        }
      },
      {
        path: '/billingSummary',
        name: 'billingSummary',
        component: () => import('../views/DashBoard/billingSummary.vue'),
        meta: {
          requireAuth: true,
          title: 'Sales Overview',
          icon: 'el-icon-odometer',
          hidden: true
        }
      },
      {
        path: '/salesOverview',
        name: 'SalesOverview',
        component: () => import('../views/DashBoard/SalesOverview.vue'),
        meta: {
          requireAuth: true,
          title: 'Sales Overview',
          icon: 'el-icon-data-line'
        }
      },
      {
        path: '/billAnalysis',
        name: 'BillAnalysis',
        component: () => import('../views/DashBoard/BillAnalysis.vue'),
        meta: {
          requireAuth: true,
          title: '账单分析视图',
          icon: 'el-icon-pie-chart'
        }
      },
      {
        path: '/billDetailView',
        name: 'BillDetailView',
        component: () => import('../views/DashBoard/BillDetailView.vue'),
        meta: {
          requireAuth: true,
          title: '账单详情',
          icon: 'el-icon-document',
          hidden: true
        }
      },
      {
        path: '/agentDashboard',
        name: 'AgentDashboard',
        component: () => import('../views/DashBoard/agentDashboard.vue'),
        meta: {
          requireAuth: true,
          title: '代理商仪表盘',
          icon: 'el-icon-odometer',
          hidden: true
        },
        // 已退役：统一跳转到角色自适应的 Sales Overview（文件暂留以便回退）
        beforeEnter: (to, from, next) => { next('/salesOverview'); }
      },
      {
        path: '/customerDashboard',
        name: 'CustomerDashboard',
        component: () => import('../views/DashBoard/customerDashboard.vue'),
        meta: {
          requireAuth: true,
          title: '我的Dashboard',
          icon: 'el-icon-odometer',
          hidden: true
        },
        // 已退役：统一跳转到角色自适应的 Sales Overview（文件暂留以便回退）
        beforeEnter: (to, from, next) => { next('/salesOverview'); }
      },
      // 超管
      {
        path: '/adminManage',
        name: 'adminManage',
        component: () => import('../views/adminManage/adminManage.vue'),
        meta: {
          requireAuth: true,
          index: '/adminManage',
        }
      },
      // 系统管理
      {
        path: '/menuManage',
        name: 'menuManage',
        component: () => import('../views/systemManage/menuManage/menuManage.vue'),
        meta: {
          requireAuth: true,
          index: '/menuManage',
        }
      },

      {
        path: '/roleManage',
        name: 'roleManage',
        component: () => import('../views/systemManage/roleManage/roleManage.vue'),
        meta: {
          requireAuth: true,
          index: '/roleManage',
        }
      },


      {
        path: '/authorityManage',
        name: 'authorityManage',
        component: () => import('../views/systemManage/authorityManage/authorityManage.vue'),
        meta: {
          requireAuth: true,
          index: '/authorityManage',
        }
      },
      {
        path: 'buttonConfig/:id/:name',
        name: 'buttonConfig',
        component: () => import('../views/systemManage/buttonConfig/buttonConfig.vue'),
        meta: {
          requireAuth: true,
          index: '/buttonConfig',
        }
      },
        {
        path: '/buttonManage',
        name: 'buttonManage',
        component: () => import('../views/systemManage/button/buttonManage.vue'),
        meta: {
          requireAuth: true,
          index: '/buttonManage',
        }
      },
      
      {
        path: '/personalCenter',
        name: 'personalCenter',
        component: () => import('../views/personalCenter/personalCenter.vue'),
        meta: {
          requireAuth: true,
          index: '/personalCenter',
        }
      },
      {
        path: '/checkRebate',
        name: 'checkRebate',
        component: () => import('../views/checkRebate/checkRebate.vue'),
        meta: {
          requireAuth: true,
        }
      },
      // 账户管理相关路由
      {
        path: '/payerManage',
        name: 'payerManage',
        component: () => import('../views/accountManage/payerManage.vue'),
        meta: {
          requireAuth: true,
          index: '/payerManage',
        }
      },
      {
        path: '/organizationManage',
        name: 'organizationManage',
        component: () => import('../views/accountManage/organizationManage.vue'),
        meta: {
          requireAuth: true,
          index: '/organizationManage',
        }
      },
      {
        path: '/saleManage',
        name: 'saleManage',
        component: () => import('../views/accountManage/saleManage.vue'),
        meta: {
          requireAuth: true,
          index: '/saleManage',
        }
      },
      {
        path: '/agentManage',
        name: 'agentManage',
        component: () => import('../views/accountManage/agentManage.vue'),
        meta: {
          requireAuth: true,
          index: '/agentManage',
        }
      },
      {
        path: '/customerManage',
        name: 'customerManage',
        component: () => import('../views/accountManage/customerManage.vue'),
        meta: {
          requireAuth: true,
          index: '/customerManage',
        }
      },
      {
        path: '/linkerManage',
        name: 'linkerManage',
        component: () => import('../views/accountManage/linkerManage.vue'),
        meta: {
          requireAuth: true,
          index: '/linkerManage',
        }
      },
      // {
      //   path: '/dataSyncManage',
      //   name: 'dataSyncManage',
      //   component: () => import('../views/accountManage/dataSyncManage.vue'),
      //   meta: {
      //     requireAuth: true,
      //     index: '/dataSyncManage',
      //   }
      // },
      // 子账号管理
      {
        path: '/subAccountManage',
        name: 'subAccountManage',
        component: () => import('../views/partnerManage/subAccountManage.vue'),
        meta: {
          requireAuth: true,
          index: '/subAccountManage',
        }
      },
      // 成本管理模块（新增）
      {
        path: '/costOverview',
        name: 'costOverview',
        component: () => import('../views/DashBoard/CostOverview.vue'),
        meta: {
          requireAuth: true,
          index: '/costOverview',
        }
      },
      {
        path: '/costExplorer',
        name: 'costExplorer',
        component: () => import('../views/DashBoard/CostExplorer.vue'),
        meta: {
          requireAuth: true,
          index: '/costExplorer',
        }
      },
      {
        path: '/rispSummary',
        name: 'rispSummary',
        component: () => import('../views/DashBoard/rispSummary.vue'),
        meta: {
          requireAuth: true,
          index: '/rispSummary',
        }
      },
      {
        path: '/costAlerts',
        name: 'costAlerts',
        component: () => import('../views/DashBoard/costAlerts.vue'),
        meta: {
          requireAuth: true,
          index: '/costAlerts',
        }
      },
      {
        path: '/opportunityManage',
        name: 'opportunityManage',
        component: () => import('../views/opportunity/opportunityManage.vue'),
        meta: {
          requireAuth: true,
          index: '/opportunityManage',
        }
      },
      // 账单管理相关路由
      {
        path: '/billManage',
        name: 'billManage',
        component: () => import('../views/bill/billManage.vue'),
        meta: {
          requireAuth: true,
          index: '/billManage',
        }
      },
      {
        path: '/sppBilling',
        name: 'sppBilling',
        component: () => import('../views/bill/sppBilling.vue'),
        meta: {
          requireAuth: true,
          index: '/sppBilling',
        }
      },
      {
        path: '/overdueManage',
        name: 'overdueManage',
        component: () => import('../views/bill/overdueManage.vue'),
        meta: {
          requireAuth: true,
          index: '/overdueManage',
        }
      },
      {
        path: '/billAnalysisView',
        name: 'billAnalysisView',
        component: () => import('../views/bill/billAnalysisView.vue'),
        meta: {
          requireAuth: true,
          index: '/billAnalysisView',
        }
      },
      {
        path: '/billDetail',
        name: 'billDetail',
        component: () => import('../views/bill/billDetail.vue'),
        meta: {
          requireAuth: true,
          index: '/billDetail',
        }
      },
      {
        path: '/departManage',
        name: 'departManage',
        component: () => import('../views/bill/departManage.vue'),
        meta: {
          requireAuth: true,
          index: '/departManage',
        }
      },
      {
        path: '/systemMonitor',
        name: '系统监控',
        meta: {
          requireAuth: true,
          title: '系统监控',
          icon: 'el-icon-monitor'
        },
        children: [
          {
            path: 'loginLog',
            name: 'loginLog',
            component: () => import('@/views/systemManage/loginLog/loginLog.vue'),
            meta: {
              requireAuth: true,
              title: '登录日志',
              icon: 'el-icon-document'
            }
          },
          {
            path: 'downloadLog',
            name: 'downloadLog',
            component: () => import('../views/downloadLog/downloadLog.vue'),
            meta: {
              requireAuth: true,
              title: '下载日志',
              icon: 'el-icon-download'
            }
          }
        ]
      },
      // {
      //   path: '/systemManage/systemLog',
      //   name: 'systemLog',
      //   component: () => import('../views/systemManage/systemLog/systemLog.vue'),
      //   meta: {
      //     requireAuth: true,
      //     index: '/systemManage/systemLog',
      //   }
      // },
    ]
  }
]

// 路由自动化注册（默认注册到index的children里面）(静态路由优先级高于动态自动路由)
const requireComponent = require.context('../views', true, /\.vue$/) // 找到 modules 路径下的所有文件
const names = requireComponent.keys()
const autoRouters = getAutoRouterList(names)
function getAutoRouterList(names) {
    // 暂时启用自动路由注册以解决404问题
    const routerList = [];
    names.forEach((name, index) => {
        if(name.indexOf("/components/")==-1 && name !='./index.vue' &&  name !='./login.vue' &&  name !='./lyterminal.vue'){
            let isSame = false
            const componentConfig = requireComponent(name)
            const componentName = name.split('/').pop()?.split('.')[0]//根据路径截取name文件名（去除后缀和前面目录）
            for(var i=0;i<routes.length;i++){
                if(routes[i].path=="/"||routes[i].path=="/login" ||routes[i].path=="/lyterminal"){
                    continue
                }
                if(routes[i].name === componentName){
                    isSame = true
                    break
                }
                if(routes[i].path === '/index' && routes[i].children.length>0){
                    for(var s=0;s<routes[i].children.length;s++){
                          if(routes[i].children[s].name === componentName){
                              isSame = true
                              break
                          }
                    }
                }
            }
            if(!isSame){
                const path = "/"+componentName
                routerList.push({
                    path: path,
                    name: componentName,
                    component:componentConfig.default,
                    meta: {
                        requireAuth: true,
                        index: path,
                    }
                });
            }
        }

    });
    for(var t=0;t<routes.length;t++){
        if(routes[t].path == '/index'){
            routerList.forEach(drouter=>{
                routes[t].children.push(drouter)
            })
            break
        }
    }
    return routerList;
}

const router = createRouter({
  //history模式
  // history: createWebHistory(process.env.BASE_URL),
  //hash模式
  history: createWebHashHistory(),
  routes: routes
})

//判断访问路径路由name是否存在
function isRouterNameExist(name){
    let isExist = false
    if(name){
        if(routes.some(item=> name == item.name)){
            return true
        }
        for(var t=0;t<routes.length;t++){
            if(routes[t].children && routes[t].children.length>0){
                if(routes[t].children.some(item=> name == item.name)){
                    isExist = true
                    break
                }
            }
        }
    }else{
        return false
    }
    return isExist
}
//判断访问路径路由path是否存在
function isRouterPathExist(path){
    let isExist = false
    if(path){
        if(routes.some(item=>path == item.path)){
            return true
        }
        for(var t=0;t<routes.length;t++){
            if(routes[t].children && routes[t].children.length>0){
                if(routes[t].children.some(item=> path == item.path)){
                    isExist = true
                    break
                }
            }
        }
    }else{
        return false
    }
    return isExist
}

// 添加安全的storage操作函数
function safeGetStorage(key, defaultValue = null) {
    try {
        const value = getStorage(key)
        return value || defaultValue
    } catch (e) {
        console.warn(`获取storage失败: ${key}`, e)
        return defaultValue
    }
}

// 添加路由健康检查函数
function checkRouteHealth() {
    console.log('路由健康检查:')
    console.log('- 总路由数量:', routes.length)
    
    const indexRoute = routes.find(r => r.path === '/index')
    if (indexRoute && indexRoute.children) {
        console.log('- 子路由数量:', indexRoute.children.length)
        console.log('- 可用路由名称:', indexRoute.children.map(r => r.name))
    }
    
    const userId = safeGetStorage('userId')
    const menuList = safeGetStorage('menuList')
    console.log('- 用户ID:', userId)
    console.log('- 菜单列表:', menuList ? 'loaded' : 'empty')
}

function safeParseJSON(str, defaultValue = null) {
    try {
        return str ? JSON.parse(str) : defaultValue
    } catch (e) {
        console.warn('JSON解析失败:', str, e)
        return defaultValue
    }
}

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
    const store = useMutitabsStore()
    // 白名单 - 这些页面即使没有菜单权限也可以访问
    const whiteList = ['buttonConfig', 'menuManage', 'lyterminal', 'buttonManage', 'Dashboard', 'AgentDashboard', 'CustomerDashboard', 'billingSummary', 'loginLog', 'downloadLog', 
      'agentManage', 'adminManage', 'roleManage', 'authorityManage', 'personalCenter', 'checkRebate', 'systemMonitor', 'organizationManage',
      'payerManage', 'saleManage', 'customerManage', 'linkerManage', 'dataSyncManage', 'subAccountManage', 'billManage', 'billAnalysisView', 'billDetail', 'departManage', 'root', 'login', '404',
      'billManageDemo', 'SalesOverview', 'BillAnalysis', 'BillDetailView',
      'costOverview', 'costExplorer', 'rispSummary', 'costAlerts']
    
    // 进度条
    NProgress.start()
    let userId = store.userId ? store.userId : ''
    
    // 调试信息
    console.log('路由导航:', {
        to: { path: to.path, name: to.name },
        from: { path: from.path, name: from.name },
        userId: userId,
        requireAuth: to.meta.requireAuth
    })
    
    // 在首次访问时进行健康检查
    if (from.path === '/' && to.path !== '/login') {
        checkRouteHealth()
    }
    
    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
        if (userId) { // 通过vuex state获取当前的token是否存在
            // 角色访问限制：伙伴(2)/客户(4) 禁止访问 SPP 出账
            const _denyUi = JSON.parse(localStorage.getItem('userInfo') || '{}')
            const ROLE_DENY = { 2: ['sppBilling', 'opportunityManage'], 4: ['sppBilling', 'opportunityManage'] }
            const _denyList = ROLE_DENY[_denyUi.type] || []
            if (_denyList.indexOf(to.name) !== -1) {
                console.warn('角色无权访问:', to.name, '跳转 SalesOverview')
                NProgress.done()
                next({ path: '/salesOverview' })
                return
            }
            // 安全地解析menuList
            let menuList = []
            try {
                const menuListStr = safeGetStorage('menuList')
                if (menuListStr) {
                    menuList = safeParseJSON(menuListStr)
                }
            } catch (e) {
                console.warn('解析menuList失败:', e)
                menuList = []
            }
            
            // 检查用户是否有权限访问该路由
            // 如果menuList为空（首次登录或数据异常），允许访问白名单中的路由
            // Dashboard、AgentDashboard、CustomerDashboard始终允许访问
            const dashboardPages = ['Dashboard', 'AgentDashboard', 'CustomerDashboard', 'billingSummary']
            const hasPermission = menuList.length === 0 ? 
                                (whiteList.indexOf(to.name) !== -1 || dashboardPages.indexOf(to.name) !== -1) :
                                (menuList.filter(item => item.url == to.name).length > 0 || whiteList.indexOf(to.name) !== -1 || dashboardPages.indexOf(to.name) !== -1)
                                
            if (hasPermission) {
                // 检查路由是否存在
                if (isRouterNameExist(to.name) || isRouterPathExist(to.path)) {
                    next()
                } else {
                    console.warn('路由不存在:', to.path, to.name)
                    next({
                        path: '/404'
                    })
                }
            } else {
                console.warn('无权限访问:', to.name, '尝试跳转到默认页面')
                // 如果没有权限访问目标页面，尝试跳转到用户有权限的默认页面
                if (menuList.length > 0) {
                    // 从菜单列表中找第一个可访问的页面
                    const firstAvailableMenu = menuList.find(item => 
                        item.url && isRouterNameExist(item.url)
                    )
                    if (firstAvailableMenu) {
                        next({
                            name: firstAvailableMenu.url
                        })
                    } else {
                        // 如果菜单中没有可用页面，跳转到默认白名单页面
                        next({
                            path: '/salesOverview'
                        })
                    }
                } else {
                    // 如果没有菜单，跳转到默认页面
                    next({
                        path: '/salesOverview'
                    })
                }
            }
        } else {
            store.logout('false')
            next({
              path: '/login'
            })
        }
    } else {
        // 处理不需要登录权限的路由
        if (to.path === "/login" || to.path === "/") {
            if (userId) {
                // 已登录用户访问登录页，重定向到之前访问的页面或默认页面
                let tabsValue = safeGetStorage("TabsValue")
                if (tabsValue && isRouterNameExist(tabsValue) && tabsValue !== 'login' && tabsValue !== 'root') {
                    store.switchtab(tabsValue)
                    return // 阻止继续执行
                } else {
                    // 尝试从tabsPage获取默认页面
                    try {
                        const tabsPageStr = safeGetStorage("tabsPage")
                        if (tabsPageStr) {
                            let tabsPage = safeParseJSON(tabsPageStr)
                            if (tabsPage && tabsPage.length > 0 && isRouterNameExist(tabsPage[0].name)) {
                                store.switchtab(tabsPage[0].name)
                                return // 阻止继续执行
                            }
                        }
                    } catch (e) {
                        console.warn('解析tabsPage失败:', e)
                    }
                    
                    // 默认跳转到仪表盘，如果仪表盘不存在则跳转到管理员管理
                    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
                    // 所有角色（含伙伴2/客户4）统一进入角色自适应的 Sales Overview
                    if (isRouterNameExist('SalesOverview')) {
                        next({ path: '/salesOverview' });
                    } else if (isRouterNameExist('adminManage')) {
                        next({ path: '/adminManage' });
                    } else {
                        // 如果都不存在，跳转到第一个有效的白名单路由
                        const availableRoute = whiteList.find(routeName => 
                            routeName !== 'root' && routeName !== 'login' && routeName !== '404' && 
                            isRouterNameExist(routeName)
                        )
                        if (availableRoute) {
                            next({
                                name: availableRoute
                            })
                        } else {
                            next({
                                path: '/404'
                            })
                        }
                    }
                }
            } else {
                // 未登录用户访问根路径或登录页，正常放行
                if (to.path === "/") {
                    // 根路径重定向到登录页
                    next({
                        path: '/login'
                    })
                } else if (isRouterNameExist(to.name) || isRouterPathExist(to.path)) {
                    next()
                } else {
                    // 如果路由不存在，重定向到登录页
                    next({
                        path: '/login'
                    })
                }
            }
        } else {
            // 其他不需要登录权限的路由
            if (isRouterNameExist(to.name) || isRouterPathExist(to.path)) {
                next()
            } else {
                console.warn('路由不存在:', to.path, to.name)
                next({
                    path: '/404'
                })
            }
        }
    }
})
//在路由跳转后用NProgress.done()标记下结束
router.afterEach((to, from, failure) => {
  NProgress.done()
  
  // 如果跳转到404页面，记录详细信息用于调试
  if (to.path === '/404') {
    console.error('路由跳转到404页面:', {
      to: { path: to.path, name: to.name },
      from: { path: from.path, name: from.name },
      failure: failure,
      timestamp: new Date().toISOString()
    })
  }
})

// 添加全局错误处理
router.onError((error) => {
  console.error('路由错误:', error)
  NProgress.done()
})

export default router